export default {
  ru: "RU",
  en: "EN",
  CoursesTitle: "Cursos | " + process.env.VUE_APP_INSTALL_NAME + "",
  Module_AI: {
    title: "Inteligência Artificial",
    desc: "Análise de imagens médicas com serviços de IA",
  },
  Module_edu: {
    title: "Educação",
    desc: "Simuladores, cursos e materiais úteis para médicos",
  },
  Module_community: {
    title: "Comunidade",
    desc: "Compartilhamento de conhecimento entre médicos e discussão de casos clínicos",
  },
  Profile: "Perfil",
  Subscription: "Assinatura",
  "Go to site": "Ir para o site",
  "Access after pay": "Aula ainda não disponível",
  Exit: "Sair",
  MY: "Painel",
  Home: "Início",
  "Mobile banner text : demo":
    "Crie uma conta e tenha acesso completo aos serviços de IA e simuladores",
  Platform: "PLATAFORMA PARA MÉDICOS",
  "Platform info":
    "Assistentes de IA, simuladores, cursos e materiais úteis para médicos",
  "Download app": "Baixar aplicativo",
  "Home title":
    "Plataforma para médicos | " + process.env.VUE_APP_INSTALL_NAME + "",
  AI: "IA",
  edu: "Educação",
  community: "Comunidade",
  "Your courses": "Seus cursos",
  "Recomended courses": "Cursos recomendados",
  Courses: "Cursos",
  Calculator: "Calculadora",
  Plug: "Conectar",
  "Go to": "Ir para",
  Case: "Tarefa",
  Cases: "Tarefas",
  "Case success": "Concluído",
  "Case unsuccess": "Não concluído",
  Modality: "Modalidade",
  "Page title tail": " | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Cant find service?": "Não encontrou o serviço necessário?",
  "Text us": "Escreva para nós",
  "I need AI for...": "Preciso de IA para...",
  "Thx for reply": "Obrigado pela sugestão!",
  Send: "Enviar",
  Sent: "Enviado",
  "Cannot loading reply -- adblock":
    "Falha no envio. Desative extensões como VPN e bloqueadores de anúncios",
  Favorites: "Favoritos",
  "Cases about 1": "Adicione seu caso",
  "Cases about 2":
    "Discuta casos interessantes, faça perguntas, compartilhe experiências! Adicione um caso, todos os estudos",
  "Cases about 3": "serão anonimizados",
  "Add case": "Adicionar caso",
  All: "Todos",
  "I upload": "Carregados",
  drafts: "Rascunhos",
  draft: "Rascunho",
  "Case v2": "Caso",
  "Open study": "Abrir estudo",
  Comments: "Comentários",
  "Comment placeholder": "Escreva um comentário...",
  "Favorites about 1": "Ainda não há nada aqui, clique no ícone",
  "Favorites about 2": "de um caso interessante para adicioná-lo aos favoritos",
  "Comment screen info 1": "Para adicionar uma captura de tela, ",
  "Comment screen info 2": "abra o estudo no visualizador",
  Download: "Baixar",
  "Record Date": "Data da gravação",
  "Request a course": "Inscrever-se",
  "Request a course doned": "Você se inscreveu no curso",
  "Forgot password?": "Esqueceu a senha?",
  "Reset password": "Redefinir senha",
  "Reset password v2": "Recuperar senha",
  "Reset password about":
    "Informe o e-mail usado no cadastro. Enviaremos instruções para redefinir sua senha",
  "Reset password about after":
    "O link para redefinição de senha foi enviado para seu e-mail",
  "Back to prev page": "Voltar",
  Email: "E-mail",
  "Not valid email": "Formato de e-mail inválido",
  EmailAlreadyRegistered: "E-mail já está registrado",
  NotActivatedAccount: "O usuário existe, mas a conta ainda não foi ativada.",
  "Not found email": "E-mail não registrado",
  "Back to login": "Voltar para login",
  "Email not come?": "Não recebeu o e-mail?",
  "Write to support": "Contatar suporte",
  "Create new password": "Crie uma nova senha",
  "Password confirm": "Confirmar senha",
  "Min 8": "Mínimo de 8 caracteres",
  "Two inputs don't match!": "As senhas não coincidem",
  "Update password": "Atualizar senha",
  "Password updated": "Senha atualizada",
  "Invalid password token": "Link inválido, tente novamente",
  "Unknown user": "Usuário desconhecido",
  "Attach image": "Anexar imagem",
  Remove: "Remover",
  Complain: "Reportar",
  "Complain sent": "Sua denúncia foi enviada com sucesso",
  owner: "Autor",
  assistant: "Tutor",
  "Answers 1": "resposta",
  "Answers 2": "respostas",
  "Answers 3": "respostas",
  "Add answer": "Responder",
  "Collapse answers": "Recolher",
  "Image only": "<Imagem>",
  "Cannot upload from mobile":
    "Você pode carregar estudos em formato DICOM a partir de um computador",
  "Password rule": "Insira pelo menos 8 caracteres, 1 letra latina e 1 número",
  ReferenceCursors: "C - Cursor 3D",
  "bad browser for mpr":
    "MPR pode não estar disponível. Recomendamos usar a versão mais recente do Google Chrome",
  "Service in process": "Carregamento temporariamente indisponível",
  "Service in process about":
    "Mas você pode explorar a funcionalidade com estudos demonstrativos. Iremos notificá-lo assim que o processamento de seus estudos estiver disponível.",
  "Edit case": "Editar caso",
  Title: "Título",
  "Access count": "Acessível para",
  "Access count about":
    "Se escolher a opção 'Disponível para todos', a publicação será visível para todos. Caso o acesso seja por link, será visível apenas por meio do botão 'Compartilhar'.",
  "To All": "Para todos",
  "To Link": "Por link",
  Publish: "Publicar",
  "Publish about":
    "Na publicação anônima seu nome e empresa não serão visíveis para outros usuários.",
  How: "Como",
  "As Anon": "Anônimo",
  "Case accept": "Eu não publico dados pessoais do paciente.",
  "User Policy": "Política de privacidade",
  "Remove case": "Excluir caso",
  "Save draft": "Salvar rascunho",
  "Remove case success": "Caso excluído com sucesso",
  "Remove case error": "Falha ao excluir caso. Tente mais tarde",
  "Update case error": "Falha ao atualizar caso. Tente mais tarde",
  Edit: "Editar",
  "Cases v2": "Casos",
  sec: " seg",
  "Confirm accept": "Confirmar aceitação",
  "Remove case?": "Excluir série?",
  "Upload AI": "Envie o estudo no formato DICOM",
  "Upload edu": "Envie o caso no formato DICOM, JPEG ou PNG",
  "Upload community": "Envie o caso no formato DICOM, JPEG ou PNG",
  "As anon": "Anônimo",
  status: {
    free: "Grátis",
    subscription: "Por assinatura",
    draft: "Rascunho",
  },
  noAcceptResult: "Descreva com o que você discorda",
  Meta: {
    tail: "%s | " + process.env.VUE_APP_INSTALL_NAME + "",
    tail2: " | " + process.env.VUE_APP_INSTALL_NAME + "",
    default: {
      title: "Plataforma para médicos",
      desc: process.env.VUE_APP_INSTALL_DESC,
    },
    "community-cases": {
      title: "Comunidade médica",
      desc: "Comunidade online de médicos para discussão de casos interessantes, dúvidas e troca de experiências!",
    },
    home: {
      title: "Plataforma para médicos",
      desc: "Plataforma médica online: assistentes de IA, simuladores, cursos e materiais úteis para médicos",
    },
    "ai-services": {
      title: "Serviços de IA",
      desc: "Serviços de inteligência artificial para diagnóstico de doenças",
    },
    "edu-services": {
      title: "Plataforma educacional para médicos",
      desc: "Lista de cursos e base de conhecimento para médicos",
    },
  },
  "Video is unavailable": "Vídeo indisponível",
  Licence:
    '© 2025 Plataforma " + process.env.VUE_APP_INSTALL_NAME + ". Todos os direitos reservados. 121205, Moscou, Centro de Inovação Skolkovo, Rua Nobel 7, 2º andar, sala 37, estação 2',
  "Policy v2": "Política de tratamento e proteção de dados pessoais",
  "Site company": "Site da empresa",
  homepage: {
    connect: "Conectar por ",
    cost: " / mês",
    goToAI: "Processar estudos",
    notAuthSub__off: {
      title: "Desbloqueie todo o potencial do assistente de IA",
      desc: "Tenha acesso ao assistente de IA para automatizar medições e gerar relatórios",
    },
    notAuthSub__on: {
      title: "Serviços de IA para análise de imagens médicas",
      desc: "Automatiza as medições e gera um relatório do exame. Processa 3 exames gratuitamente, depois — mais por <PRICE>",
    },
    baseSub: {
      title: "Livre-se da rotina ao analisar estudos com IA",
      desc: "O assistente de IA automatiza medições e gera um relatório com um clique",
    },
    notBaseSub: {
      title: "Carregue a imagem com um clique",
      desc: "Use o assistente de IA para automatizar medições e relatórios",
    },
  },
  "Start type": "Comece a digitar...",
  buy: "Comprar",
  more_details: "Ler mais",
};
